import React, { useEffect, useState } from "react";
import { Row, Col, Button, ProgressBar } from 'react-bootstrap';

import styles from "./ProductCategory.module.css";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { Carousel } from 'react-responsive-carousel';
import { useDispatch, useSelector } from "react-redux";
import { responsiveActionTypes } from "../../redux/responsive/responsiveAction";
import { RootState } from "../../redux/rootReducer";

var slideNo = 1;

export interface IProductCategory {
    departmentId: number,
    departmentCode: string,
    departmentName: string,
    description: string,
    imageURL: string,
    pageHeaderOnClickURL: string
}
interface PropsType {
    productCategory: IProductCategory[],
}

export default function ProductCategory(props: PropsType) {
    const dispatch = useDispatch();
    var prods = props.productCategory;

    const [selectedProduct, setSelectedProduct] = useState<IProductCategory>(prods[0]);
    const [showProducts, setShowProducts] = useState<IProductCategory[]>(prods.slice(0, 6));
    const [hoverProduct, setHoverProduct] = useState<IProductCategory>(prods[0]);
    const [isWeb, setIsWeb] = useState<boolean>(true);

    const responsive = useSelector((state: RootState) => state.responsive);
    var prodsPerSlide: any;

    {
        responsive.isMobileLargeScreen
            || responsive.isMobileSmallScreen || responsive.isTabScreen
            ? prodsPerSlide = 4 : prodsPerSlide = 6
    }

    useEffect(() => {
        if (responsive.isMobileLargeScreen || responsive.isMobileSmallScreen || responsive.isTabScreen) {
            setIsWeb(false)
        }
        setSelectedProduct(prods[0]);
        setShowProducts(prods.slice(0, 6));
        setHoverProduct(prods[0]);
        showProductList(1);

    }, [])

    function plusSlides(n: number, isWeb: boolean) {
        showProductList(slideNo += n);
    }

    function mouseClick(id: number) {
        for (var i = 0; i < prods.length; i++) {
            if (prods[i].departmentId == id) {
                setSelectedProduct(prods[i]);
                setHoverProduct(prods[i]);
            }
        }
    }

    function mouseEnter(id: number) {
        for (var i = 0; i < prods.length; i++) {
            if (prods[i].departmentId == id) {
                var hoverProd: any = prods[i];
                setHoverProduct(hoverProd);
            }
        }
    }
    function mouseLeave() {
        setHoverProduct(selectedProduct);
    }

    function showProductList(n: number) {
        if (n < 1) {
            slideNo = 1;
        }
        if (n * prodsPerSlide > prods.length) {
            slideNo = Math.floor(prods.length / prodsPerSlide) + 1;
        }
        var noOfSlides = slideNo * prodsPerSlide;
        if ((noOfSlides) > prods.length) {
            if ((((slideNo - 1) * prodsPerSlide)) < prods.length) {
                noOfSlides = prods.length;
                var newArray = prods.slice((slideNo - 1) * prodsPerSlide, noOfSlides);
                setShowProducts(newArray);
            }
            else {
                slideNo = slideNo - 1;
            }
        }
        else {
            var newArray = prods.slice((noOfSlides) - prodsPerSlide, noOfSlides);
            setShowProducts(newArray);
        }
    }

    function dotValue(maxLength: number) {
        var val = ((slideNo - 1) * prodsPerSlide) + showProducts.length;
        if (val < 10) {
            return '0' + val;
        }
        if (val > maxLength) {
            val = maxLength
        }
        return val;
    }

    return (
        prods.length != 0 ?
            <React.Fragment>
                <div className={`${styles.mainContainer}`}>
                    <div className={`${styles.slideshowContainer}`} >
                        <Row className="col-12" >
                            <Col lg="4" md="4" xs="12" className={`${styles.selectedDetailSection}`} style={{ paddingLeft: isWeb ? "7rem" : "2rem", paddingBottom: isWeb ? "" : "0rem" }}>
                                <Row>
                                    <Col lg="12" md="12" xs="12" className={`${styles.selectedBrandHeading}`} style={{ textTransform: "capitalize", fontFamily: "Montserrat-medium" }}>
                                        <p>Our Products</p>
                                    </Col>
                                    <Col lg="12" md="12" xs="12" className={`${styles.mainHeading}`}>
                                        <p style={{ lineHeight: "1" }}>PRODUCT CATEGORIES</p>
                                    </Col>
                                    <Col lg="12" md="12" xs="12" style={{ marginBottom: "0rem" }}>
                                        <p>Explore the range of products we offer to improve efficiency in your business and in your home </p>
                                    </Col>
                                    <Col lg="12" md="12" xs="12">
                                        <div>
                                            <Button onClick={() => {
                                                window.location.href = "/products/all";
                                            }}
                                                className="jkoa-transparent-btn">Explore
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            {isWeb ?
                                <>
                                    <Col lg="4" md="4" xs="12" className={`${styles.selectedDetailSection}`} style={{ justifyContent: "center" }}>
                                        <Row>
                                            <Col lg="12" md="12" xs="12" className={`${styles.mainHeading} ${styles.fade}`} style={{ margin: "2rem 0 0 0" }}>
                                                <div className={`${styles.mainImageContainer}`} >
                                                    <img className={`${styles.mainImage}`} src={hoverProduct.imageURL} />
                                                </div>
                                            </Col>

                                        </Row>
                                    </Col>
                                    <Col lg="4" md="4" xs="12" className={`${styles.selectedDetailSection}`}>
                                        <Row>
                                            <Col lg="12" md="12" xs="12" className={`${styles.mainHeading}`}>
                                                <span className={`${styles.categoryName}`} >{hoverProduct.departmentName}</span>
                                            </Col>
                                            <Col lg="12" md="12" xs="12">
                                                <p>{hoverProduct.description}</p>
                                            </Col>
                                            <Col lg="12" md="12" xs="12">
                                                <div>
                                                    <Button
                                                        className="jkoa-blue-btn" style={{ borderColor: "transparent" }}
                                                        onClick={() => {
                                                            window.location.href = `/products/${hoverProduct.departmentName.replace(/[/ ]/g, "_").toLowerCase()}`;
                                                        }}>
                                                        <div style={{ padding: "0.3rem 1rem" }}> Explore</div>
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </> : null
                            }
                        </Row>
                        <Row style={{ paddingBottom: isWeb ? "" : "0rem" }}>
                            <Col className={`${styles.brandsSection}`} style={{ padding: isWeb ? "" : "0 0 0 0" }}>
                                <Row>
                                    {showProducts.map((item: IProductCategory, index) => {
                                        return (
                                            <>
                                                {isWeb ?
                                                    <Col key={item.departmentId} lg="4" md="4" xs="12" className={`${styles.fade} d-flex justify-content-center`}
                                                        onClick={() => mouseClick(item.departmentId)} onMouseEnter={() => mouseEnter(item.departmentId)} onMouseLeave={() => mouseLeave()}>

                                                        <div className={`${styles.brandSection} ${styles.fade}`}>
                                                            <div className={`${styles.whiteBox}`}></div>
                                                            <Col lg="4" md="4" xs="12">
                                                                <Row>
                                                                    <Col lg="12" md="12" xs="12" style={{ padding: 0 }}>
                                                                        <img className={`${styles.imgProd}`} src={item.imageURL}
                                                                            onError={(e: any) => { e.target.onerror = null; e.target.src = "https://sajkoaonline.blob.core.windows.net/jkoa/itemimage/350/jkoa_default.png" }} />
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                            <Col style={{ position: "relative" }}>
                                                                <Row style={{ padding: "0 5px 0 10px" }}>
                                                                    <Col lg="12" md="12" xs="12" className={`${styles.selectedBrandHeading}`} style={{ height: "25px", lineHeight: "15px" }}>
                                                                        <span>{item.departmentName}</span>
                                                                    </Col>
                                                                    <Col lg="12" md="12" xs="12" className={`${styles.mainText}`}>
                                                                        <p className={`${styles.lineClamp}`}>{item.description}</p>
                                                                    </Col>
                                                                    <Col lg="12" md="12" xs="12" >
                                                                        <Button onClick={() => {
                                                                            window.location.href = item.departmentCode == "D12" ? "/pnpl" : `/products/${hoverProduct.departmentName.replace(/[/ ]/g, "_").toLowerCase()}`;
                                                                        }}
                                                                            className={`${styles.exploreLink} jkoa-underline-btn`} >  Explore
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </div>
                                                    </Col>
                                                    :
                                                    <Col key={item.departmentId} lg="4" md="4" xs="6" className={`${styles.fade} ${styles.mobileColumns} d-flex justify-content-center`}
                                                        onClick={() => {
                                                            window.location.href = item.departmentCode == "D12" ? "/pnpl" : `/products/${hoverProduct.departmentName.replace(/[/ ]/g, "_").toLowerCase()}`;
                                                        }}>

                                                        <div className={`${styles.brandSectionMobile} ${styles.fade}`}>
                                                            <div className={`${styles.whiteBoxMobile}`}></div>
                                                            <Row>
                                                                <Col lg="5" md="5" xs="12">
                                                                    <Row>
                                                                        <Col lg="12" md="12" xs="12" style={{ display: "flex", padding: "0", justifyContent: "center" }}>
                                                                            <img className={`img-fluid ${styles.imgProd_mobile}`} src={item.imageURL}
                                                                                onError={(e: any) => { e.target.onerror = null; e.target.src = "https://sajkoaonline.blob.core.windows.net/jkoa/itemimage/350/jkoa_default.png" }} />
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                                <Col style={{ position: "relative" }}>
                                                                    <Row style={{ padding: "0px 0px 0px 15px" }}>
                                                                        <Col lg="12" md="12" xs="12" className={`${styles.selectedBrandHeadingMobile}`} style={{ height: "25px", lineHeight: "15px", paddingLeft: "1" }}>
                                                                            <span style={{ justifyContent: "center" }}>{item.departmentName}</span>
                                                                        </Col>
                                                                        <Col lg="12" md="12" xs="12" className={`${styles.mainText}`} style={{ paddingLeft: "0" }} hidden>
                                                                            <p className={`${styles.lineClamp}`}>{item.description}</p>
                                                                        </Col>
                                                                        <Col lg="12" md="12" xs="12" style={{ paddingLeft: "0" }} hidden>
                                                                            <Button onClick={() => {
                                                                                window.location.href = item.departmentCode == "D12" ? "/pnpl" : `/products/${hoverProduct.departmentName.replace(/[/ ]/g, "_").toLowerCase()}`;
                                                                            }}
                                                                                className="jkoa-underline-btn" style={{ paddingLeft: "10px" }}>  Explore
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                }
                                            </>
                                        );
                                    })}
                                </Row>
                            </Col>
                        </Row>
                        {/* {!isWeb
                            ? null : */}
                        <Row className={`${styles.arrowkeys}`}>
                            <Col lg="2" md="3" xs="3" className={`${styles.progressBarSelected}`}>
                                <p>{dotValue(prods.length)}/{prods.length}</p>
                                {isWeb ?
                                    <ProgressBar style={{ height: "0.25rem" }} now={((((slideNo - 1) * prodsPerSlide) + showProducts.length) / prods.length) * 100} />
                                    : null}
                            </Col>
                            <Col style={{ bottom: "0", display: "flex", margin: isWeb ? "2rem 0 3rem 0" : "1rem 0 3rem 0" }}>
                                <i className={` fas fa-long-arrow-alt-left fa-3x ${styles.prev}`} onClick={() => plusSlides(-1, false)} />
                                <i className={` fas fa-long-arrow-alt-right fa-3x ${styles.next}`} onClick={() => plusSlides(1, false)} />
                            </Col>
                        </Row>
                        {/* } */}
                    </div>
                </div>
            </React.Fragment >
            : null
    )
}